import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {MatCheckbox, MatCheckboxChange, MatDialog, MatStepper} from '@angular/material';
import {CreateDatabaseDuringSignUpComponent, EditDatabaseDuringSignUpComponent} from '../../../signup/signup.component';
import {ConfService} from '../../../conf.service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import * as CryptoJS from 'crypto-js';
import {environment} from '../../../../environments/environment.prod';
import {DatabaseManagerComponent} from '../../database-manager/database-manager.component';
import {LeftpanelComponent} from '../../../leftpanel/leftpanel.component';
import {EnvironmentCreatorService} from '../../../environment-creator.service';
import {CloudConstants} from '../../../constants/cloud.constants';
import {ApiGatewayConstants} from '../../../constants/apigateway.constants';
import {DatabaseConstants} from '../../../constants/database.constants';
import {AddApiGatewayComponent} from '../../api-gateway-settings/add-api-gateway/add-api-gateway.component';
import {CloudConfigsComponent} from '../../../signup/signup-configurations/cloud-configs/cloud-configs.component';
import {FilestorageConstants} from '../../../constants/filestorage.constants';

declare let $;

@Component({
  selector: 'app-environment-creation',
  templateUrl: './environment-creation.component.html',
  styleUrls: ['./environment-creation.component.scss']
})
export class EnvironmentCreationComponent implements OnInit {

  @Input() environment: any;
  @ViewChild('myCheckbox') private myCheckbox: MatCheckbox;
  @ViewChild('myCheckbox1') private myCheckbox1: MatCheckbox;
  @ViewChild(DatabaseManagerComponent) databaseManager: DatabaseManagerComponent;
  @Output() createEnvironment = new EventEmitter<{}>();

  @Output() createEnvironmentWithAPI = new EventEmitter<{}>();

  showDefaultView = true;
  hide = true;
  confirmHide = true;
  password = '';
  flag = false;
  confirmPassword: string;
  passwordValidationStatement = '';
  containsDigit = false;
  containsLowerCase = false;
  containsUpperCase = false;
  containsSpecialCharacter = false;
  loading = true;

  settingsPayload = {
    partner_name: '',
    account_name: '',
    environment_type: '',
    partner: '',
    account: '',
    email: '',
    phone_number: '',
    environments: [
      {
        name: '',
        type: '',
        cloud: [
          {
            type: 'aws',
            region: 'US-East (N.Virginia)',
            'is_default': true,
            regions: ['US-East (N.Virginia)'],
            audit_logs: [{
              action: 'CREATE',
              by: localStorage.getItem('signInEmail'),
              at: Date.now()
            }]
          }
        ],
        display_name: '',
        is_validation_complete: false,
        is_creation_complete: true,
        is_enabled: true,
        services: [
          {
            name: 'Secrets Manager',
            type: 'secretsmanager',
            configurations: [
              {
                'name': 'Default',
                'providerName': 'apiplatform.io',
                'image': './assets/img/partnerOnboarding/api.png',
                'description': 'apiplatform\'s encryption mechanism',
                'owner': 'apiplatform.io',
                'is_default': true,
                'audit_logs': [{
                  action: 'CREATE',
                  by: localStorage.getItem('signInEmail'),
                  at: Date.now()
                }]
              }
            ]
          },
          {
            name: 'Databases',
            type: 'databases',
            configurations: [
              {
                database_name: '',
                database_type: '',
                region: '',
                'is_default': true,
                database_attributes: {},
                'audit_logs': [{
                  action: 'CREATE',
                  by: localStorage.getItem('signInEmail'),
                  at: Date.now()
                }]
              }
            ]
          }
        ],
        'audit_logs': [
          {
            action: 'CREATE',
            by: localStorage.getItem('signInEmail'),
            at: Date.now()
          }
        ]
      }
    ],
    is_enabled: true,
    subscriptions: {
      providers: [],
      platform_services: [],
      platform_service_categories: []
    },
    logo: '',
    brand_image: ''
  };

  cloudProvider = 'apiplatform';
  cloudInfras = CloudConstants.cloudInfraList;
  externalCloudInfras = CloudConstants.externalCloudInfraList;

  gatewayProvider = 'apiplatform';
  gatewayProviders = ApiGatewayConstants.internalGatewayTypes;
  externalGatewayProviders = ApiGatewayConstants.externalGatewayTypes;

  databaseProvider = 'apiplatform';
  externalDatabaseConnectionData: any;
  databaseTypes = DatabaseConstants.databaseTypes;
  externalDatabasetype: any;

  fileStorageProvider = 'apiplatform';
  fileStorageTypes = FilestorageConstants.fileStorageProviders;

  defaultGateway = ['default'];
  selectedAPIGateway = {
    gateway: 'apiplatform',
    image: './assets/img/partnerOnboarding/api.png',
    description: 'Default',
    value: 'default',
    provider: 'apiplatform.io',
    gatewayURL: '',
    gateway_configurations: {}
  };

  configurationsForEnvCreation = {};
  item = {};
  envPkeys = {};

  databaseSelected = 'mongodb';
  databasesPayload = [];
  partnerShortCode: any;
  partnerAccount: any;
  firstFormGroup: FormGroup;

  iterationCount = 1000;
  keySize = 128;
  passphrase = environment.cipheringPhrase;
  loading1 = false;

  selectedCloudInfra = {
    cloudProvider: 'AWS',
    image: './assets/img/vault/awssecretsmanager.png',
    region: 'US-East (N.Virginia)',
    description: 'Host your applications in AWS',
    value: 'aws'
  };

  constructor(private dialog: MatDialog, private confPost: ConfService, private _formBuilder: FormBuilder, public platform: LeftpanelComponent) { }

  async ngOnInit() {
    this.configurationsForEnvCreation = this.platform.configurationsForEnvCreation;
    this.configurationsForEnvCreation[this.environment] = {};
    this.keySize = this.keySize / 32;
    const temp = localStorage.getItem('partner').split('-');
    const temp1 = localStorage.getItem('account').split('-');
    if (temp.length > 1) {
      this.partnerShortCode = temp[temp.length - 1];
    } else {
      this.partnerShortCode = localStorage.getItem('partner');
    }
    if (temp1.length > 1) {
      this.partnerAccount = temp1[temp1.length - 1];
    } else {
      this.partnerAccount = localStorage.getItem('partner');
    }

    this.firstFormGroup = this._formBuilder.group({
      firstCtrl: ['', Validators.required],
      secondCtrl: ['', Validators.required]
    });

    this.settingsPayload.partner_name = this.partnerShortCode;
    this.settingsPayload.account_name = this.partnerShortCode;
    this.settingsPayload.environments[0]['partner_name'] = this.partnerShortCode;
    this.settingsPayload.environments[0]['account_name'] = this.partnerShortCode;
    this.settingsPayload.environment_type = this.environment;

    if (this.environment === 'prod') {
      this.settingsPayload.partner = this.partnerShortCode;
      this.settingsPayload.account = this.partnerAccount;
      this.settingsPayload.environments[0].name = this.partnerShortCode;
      this.settingsPayload.environments[0].display_name = 'Production';
    } else {
      this.settingsPayload.partner = this.environment + '-' + this.partnerShortCode;
      this.settingsPayload.account = this.environment + '-' + this.partnerAccount;
      this.settingsPayload.environments[0].name = this.environment + '-' + this.partnerShortCode;
      switch (this.environment) {
        case 'staging':
          this.settingsPayload.environments[0].display_name = 'Staging';
          break;
        case 'qa':
          this.settingsPayload.environments[0].display_name = 'QA';
          break;
        case 'dev':
          this.settingsPayload.environments[0].display_name = 'Development';
          break;
        case 'admin':
          this.settingsPayload.environments[0].display_name = 'Administration';
          break;
        default:
          this.settingsPayload.environments[0].display_name = this.environment;
          break;
      }
    }

    this.settingsPayload.environments[0].type = this.environment;

    this.configurationsForEnvCreation[this.environment]['environmentResponseArray'] = [];
    this.configurationsForEnvCreation[this.environment]['envPartner'] = '';

    await this.confPost.getPartner(localStorage.getItem('partner'), localStorage.getItem('account')).toPromise().then(data => {
      Promise.resolve(this.getPartnerKey(localStorage.getItem('partner'), localStorage.getItem('account'), data['partnerKey'], this.environment)).then(response1 => {
        if (this.environment === 'prod') {
          this.item['partner'] = this.partnerShortCode;
        } else {
          this.item['partner'] = this.environment + '-' + this.partnerShortCode;
        }
        this.item['partner_name'] = this.partnerShortCode;
        this.item['account_name'] = this.partnerShortCode;
        this.item['environment_type'] = this.environment;
        this.item['primary_email'] = data['primary_email'];
        this.item['primary_phone'] = data['primary_phone'];
        this.item['primaryRegion'] = data['primaryRegion'];
        this.item['primaryLanguage'] = data['primaryLanguage'];
        this.item['partnerKey'] = this.envPkeys[this.environment];
        this.item['partner_organization_type'] = data['partner_organization_type'];
        this.item['partner_organization_size'] = data['partner_organization_size'];
        this.item['anticipated_api_count'] = data['anticipated_api_count'];
        this.item['expected_api_hits'] = data['expected_api_hits'];
        this.item['partner_organization'] = data['partner_organization'];
        this.item['currentPlan'] = 'Enterprise';
        this.item['planHistory'] = [
          {
            planName: 'Enterprise',
            createdDate: Date.now(),
            removedDate: ''
          }
        ]
        ;
        this.item['accounts'] = [
          {
            // account: this.partnerAccount,
            account_desc: 'default',
            account_email: this.item['primary_email'],
            account_phone: this.item['primary_phone'],
            account_roles: [],
            entities: [],
            operations: []
          }
        ];
        this.item['isActive'] = true;
        if (this.environment === 'prod') {
          this.item['accounts'][0]['account_id'] = this.partnerAccount;
        } else {
          this.item['accounts'][0]['account_id'] = this.environment + '-' + this.partnerAccount;
        }

        // if (data['databases'].length > 0) {
        //   this.item['databases'] = data['databases'];
        //   this.item['defaultDatabaseType'] = data['defaultDatabaseType'];
        // } else {
        //   this.item['databases'] = [];
        //   this.item['defaultDatabaseType'] = data['defaultDatabaseType'];
        // }
        this.settingsPayload.email = data['primary_email'];
        this.settingsPayload.phone_number = data['primary_phone'];
        this.configurationsForEnvCreation[this.environment]['partnerPayload'] = this.item;
        this.configurationsForEnvCreation[this.environment]['settingsPayload'] = this.settingsPayload;
        this.loading = false;
      }, error => {
        this.loading = false;
      });
    }, error => {
      this.loading = false;
    });
  }

  selectCloudInfra(event) {
    this.selectedCloudInfra = event;
    this.configurationsForEnvCreation[this.environment]['settingsPayload']['environments'][0]['cloud'][0]['type'] = this.selectedCloudInfra.value;
    this.configurationsForEnvCreation[this.environment]['settingsPayload']['environments'][0]['cloud'][0]['primary_region'] = this.selectedCloudInfra.region;
    this.configurationsForEnvCreation[this.environment]['settingsPayload']['environments'][0]['cloud'][0]['regions'][0] = this.selectedCloudInfra.region;
  }

  selectAPIGateway(event) {
    this.selectedAPIGateway = event;
  }

  encrypt (salt, iv, passPhrase, plainText, keySize, iterationCount) {
    const key = CryptoJS.PBKDF2(passPhrase, CryptoJS.enc.Hex.parse(salt), { keySize: keySize, iterations: iterationCount });
    const encrypted = CryptoJS.AES.encrypt(
        plainText,
        key,
        { iv: CryptoJS.enc.Hex.parse(iv) });
    return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
  }

  async getPartnerKey(partner, account, key, environment) {
    return new Promise(async (resolve, reject) => {
      await this.confPost.generatePartnerKey(partner, account, key).subscribe(response => {
        this.item['partnerKey'] = response['token'];
        this.envPkeys[environment] = response['token'];
        resolve('success');
      });
    });
  }
  formValidation() {
    if (this.password === this.confirmPassword && this.password !== '' && this.confirmPassword !== '' ) {
      this.passwordPolicyValidator().then(response => {
        if (response) {
          this.flag = true;
          this.passwordValidationStatement = 'Passwords matches and follows our password policy';
        } else {
          this.flag = false;
          this.passwordValidationStatement = 'Please make sure that your password follows our password policy';
        }
      });
    } else {
      this.passwordValidationStatement = 'Passwords do not match';
      this.flag = false;
    }
  }

  passwordPolicyValidator() {
    return new Promise((resolve, reject) => {
      let i = 0;
      let character = '';
      if (this.password) {
        this.containsDigit = false;
        this.containsLowerCase = false;
        this.containsUpperCase = false;
        this.containsSpecialCharacter = false;
        if (this.password.length < 8) {
          resolve(false);
        } else {
          while (i <= this.password.length) {
            character = this.password.charAt(i);
            if (character.charCodeAt(0) >= 48 && character.charCodeAt(0) <= 57) {
              this.containsDigit = true;
            }
            if (character.charCodeAt(0) >= 65 && character.charCodeAt(0) <= 90) {
              this.containsUpperCase = true;
            }
            if (character.charCodeAt(0) >= 97 && character.charCodeAt(0) <= 122) {
              this.containsLowerCase = true;
            }
            if (character.charCodeAt(0) >= 32 && character.charCodeAt(0) <= 47 ||
                character.charCodeAt(0) >= 58 && character.charCodeAt(0) <= 64 ||
                character.charCodeAt(0) >= 91 && character.charCodeAt(0) <= 96 ||
                character.charCodeAt(0) >= 123 && character.charCodeAt(0) <= 126) {
              this.containsSpecialCharacter = true;
            }
            i++;
            if (i === this.password.length) {
              if (this.containsDigit && this.containsLowerCase && this.containsUpperCase && this.containsSpecialCharacter) {
                resolve(true);
              } else {
                resolve(false);
              }
            }
          }
        }
      }
    });
  }

  resetPasswordValidationStatement() {
    this.passwordValidationStatement = '';
  }

  validatePassword() {
    this.passwordPolicyValidator().then(response => {
      if (response) {
        if (this.passwordValidationStatement === '') {
        }
      } else {
        this.passwordValidationStatement = 'Please make sure that your password follows our password policy';
      }
    });
  }

  goPastApiGatewayStep(stepper: MatStepper) {
    if (this.isApiGatewayValid()) {
      stepper.next();
    } else {
      this.platform.openSnackBar('Please select an API gateway to continue.', 'Error', {
        duration: 4000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
    }
  }

  createExternalDatabase() {
    if (!this.externalDatabaseConnectionData) {
      const dialogRef = this.dialog.open(CreateDatabaseDuringSignUpComponent, {
        disableClose: true,
        width: '50%',
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.externalDatabaseConnectionData = result;
          this.externalDatabasetype = this.databaseTypes.find(databaseType => databaseType.value === result.database_type);

        } else {
          this.databaseProvider = 'apiplatform';
        }
      });
    }
  }

  editExternalDatabase() {
    const dialogRef = this.dialog.open(EditDatabaseDuringSignUpComponent, {
      disableClose: true,
      width: '50%',
      data: [this.externalDatabaseConnectionData]
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.externalDatabaseConnectionData = result;
        this.externalDatabasetype = this.databaseTypes.find(databaseType => databaseType.value === result.database_type);
      }
    });
  }

  databaseChanged(index, changeValue = false) {
    this.databaseTypes.forEach((database, i) => {
      if (!database.disabled) {
        if (i !== index) {
          database.selected = false;
        } else {
          if (changeValue) {
            database.selected = !database.selected;
          }
        }
      } else {
        database.selected = false;
      }
    });
  }

  goToNextStep(stepper: MatStepper) {
    if (this.password === this.confirmPassword) {
      this.passwordPolicyValidator().then(response => {
        if (response) {
          const iv = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
          const salt = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
          // this.configurationsForEnvCreation[this.environment]['partnerPayload']['ralam'] = iv;
          // this.configurationsForEnvCreation[this.environment]['partnerPayload']['shash'] = salt;
          // this.configurationsForEnvCreation[this.environment]['partnerPayload']['account_password'] = this.encrypt(salt, iv, this.passphrase, this.password, this.keySize, this.iterationCount);
          for (const service of this.configurationsForEnvCreation[this.environment].settingsPayload.environments[0].services) {
            if (service['type'] === 'secretsmanager') {
              if (service['configurations'][0]['provider'] === 'Default' || service['configurations'][0]['provider'] === 'apiplatform.io') {
                this.configurationsForEnvCreation[this.environment]['partnerPayload']['ralam'] = iv;
                this.configurationsForEnvCreation[this.environment]['partnerPayload']['shash'] = salt;
                this.configurationsForEnvCreation[this.environment]['partnerPayload']['account_password'] = this.encrypt(salt, iv, this.passphrase, this.password, this.keySize, this.iterationCount);
                this.configurationsForEnvCreation[this.environment]['partnerPayload']['accounts'][0]['account_password'] = this.encrypt(salt, iv, this.passphrase, this.password, this.keySize, this.iterationCount);
              } else {
                this.configurationsForEnvCreation[this.environment]['partnerPayload']['account_password'] = '';
                this.configurationsForEnvCreation[this.environment]['partnerPayload']['accounts'][0]['account_password'] = '';
              }
            }
          }
          stepper.next();
        } else {
          this.passwordValidationStatement = 'Please make sure that your password follows our password policy';
        }
      });
    } else {
      this.passwordValidationStatement = 'Passwords do not match';
      // alert('Passwords do not match');
    }
  }

  selectDB() {
    this.databaseSelected = this.databaseManager.databaseSelected;
  }

  resetDatabaseView(event: MatCheckboxChange) {
    if (confirm('This action will remove all your configurations. Do you still want to continue?')) {
      this.showDefaultView = true;
      this.databasesPayload = [];
      this.databaseSelected = 'mongodb';
      this.myCheckbox1.checked = false;
    } else {
      this.myCheckbox1.checked = false;
    }
  }

  openDialog(event: MatCheckboxChange, isOnboarding) {
    if (event.checked) {
      this.databaseSelected = 'mongodb';
      const dialogRef = this.dialog.open(CreateDatabaseDuringSignUpComponent, {
        disableClose: true,
        width: '50%',
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result !== undefined) {
          this.databaseSelected = result['database_type'];
          this.databasesPayload[0] = result;
          this.myCheckbox.checked = false;
          this.showDefaultView = false;
        } else {
          this.databasesPayload = [];
          this.databaseSelected = 'mongodb';
          $('#selectedDB0').css('border', 'transparent');
          this.myCheckbox.checked = false;
        }
      });
    }
  }

  internalProviderChanged(index, changeValue = false) {
    this.gatewayProviders.forEach((database, i) => {
      if (!database.disabled) {
        if (i !== index) {
          database.selected = false;
        } else {
          if (changeValue) {
            database.selected = !database.selected;
          }
        }
      } else {
        database.selected = false;
      }
    });
  }

  isApiGatewayValid() {
    if (this.gatewayProvider === 'apiplatform') {
      const selectedGateway = this.gatewayProviders.filter(cloud => cloud.selected);
      return selectedGateway.length > 0;
    } else {
      const selectedGateway = this.externalGatewayProviders.filter(cloud => cloud.selected);
      if (selectedGateway.length > 0) {
        const hasExternalConfig = selectedGateway.every(cloud => {
          return cloud && cloud['externalConfig'] && typeof cloud['externalConfig'] === 'object';
        });

        return hasExternalConfig;
      } else {
        return false;
      }
    }
  }

  externalProviderChanged(index, changeValue = false) {
    this.externalGatewayProviders.forEach((database, i) => {
      if (!database.disabled) {
        if (i !== index) {
          database.selected = false;
        } else {
          if (changeValue) {
            database.selected = !database.selected;
          }
        }
      } else {
        database.selected = false;
      }
    });
  }

  addExternalGateway(gateway, checked) {
    if (checked) {
      const dialogRef = this.dialog.open(AddApiGatewayComponent, {
        disableClose: true,
        width: '50%',
        data: {
          apigateway: gateway.externalConfig,
          isEdit: gateway.externalConfig !== null,
          disableGatewayTypeSelector: true,
          disableGatewayNameInput: true,
          gatewayType: gateway.value,
          returnWithoutCreate: true
        },
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          gateway['externalConfig'] = result;
        } else {
          if (!gateway.externalConfig) {
            gateway['selected'] = false;
          }
        }
      });
    }
  }

  addExternalCloud(cloud, checked) {
    if (checked) {
      const dialogRef = this.dialog.open(CloudConfigsComponent, {
        disableClose: true,
        width: '50%',
        data: {
          cloudConfig: cloud,
          config: cloud.externalConfig,
          isEdit: cloud.externalConfig
        },
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          cloud['externalConfig'] = result;
        } else {
          if (!cloud.externalConfig) {
            cloud['selected'] = false;
          }
        }
      });
    }
  }

  isCloudValid() {
    if (this.cloudProvider === 'apiplatform') {
      const selectedClouds = this.cloudInfras.filter(cloud => cloud.selected);
      return selectedClouds.length > 0;
    } else {
      const selectedClouds = this.externalCloudInfras.filter(cloud => cloud.selected);
      if (selectedClouds.length > 0) {
        const hasExternalConfigWithHost = selectedClouds.every(cloud => {
          return cloud && cloud['externalConfig'] && typeof cloud['externalConfig'] === 'object' && cloud['externalConfig'].host;
        });

        return hasExternalConfigWithHost;
      } else {
        return false;
      }
    }
  }

  getDatabaseInput() {
    const request = [];

    if (this.databaseProvider === 'apiplatform') {
      const selectedDatabase = this.databaseTypes.filter(db => db.selected);
      if (selectedDatabase.length === 1) {
        request.push({
          connection_type: 'apiplatform',
          connection_name: 'default',
          database_type: selectedDatabase[0].value,
          type: 'apiplatform'
        });
      }
    } else {
      if (this.externalDatabaseConnectionData) {
        const externalConfig = JSON.parse(JSON.stringify(this.externalDatabaseConnectionData));
        externalConfig['type'] = 'external';
        externalConfig['connection_name'] = externalConfig['database_name'];
        delete externalConfig['database_name'];
        request.push(externalConfig);
      }
    }

    return request;
  }

  getApiGatewayInput() {
    let request = [];

    if (this.gatewayProvider === 'apiplatform') {
      request.push({
        cloud: 'aws',
        provider: 'apiplatform'
      });
    } else {
      const selectedGateways = this.externalGatewayProviders.filter(gateway => gateway.selected);
      request = selectedGateways.map(cloud => ({
        type: cloud.value,
        provider: cloud.provider,
        config: cloud['externalConfig']
      }));
      if (request.length === 1) {
        request[0].config['name'] = 'default';
      }
    }

    return request;
  }

  getFileStorageInput() {
    const request = [];
    if (this.fileStorageProvider === 'apiplatform') {
      const selectedFiles = this.fileStorageTypes.filter(f => f.selected);
      if (selectedFiles.length > 0) {
        request.push({
          cloud: 'aws',
          provider: 'apiplatform'
        });
      }
    }
    return request;
  }

  async setUpEnvironment() {
    if (this.password === this.confirmPassword) {
      const payload = {
        partner: this.partnerShortCode,
        email: localStorage.getItem('signInEmail'),
        environment: {
          env: this.environment,
          password: this.password,
          devex: [{
            cloud: 'aws',
            provider: 'apiplatform',
          }],
          dashboard: [{
            cloud: 'aws',
            provider: 'apiplatform'
          }],
          databases: this.getDatabaseInput(),
          apigateway: this.getApiGatewayInput()
        }
      };

      this.createEnvironmentWithAPI.emit(payload);
    } else {
      alert('Passwords do not match');
    }
    // if (this.password === this.confirmPassword) {
    //   this.loading1 = true;
    //   const iv = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
    //   const salt = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
    //   for (const service of this.configurationsForEnvCreation[this.environment].settingsPayload.environments[0].services) {
    //     if (service['type'] === 'secretsmanager') {
    //       if (service['configurations'][0]['providerName'] === 'Default' || service['configurations'][0]['providerName'] === 'apiplatform.io') {
    //         this.configurationsForEnvCreation[this.environment]['partnerPayload']['ralam'] = iv;
    //         this.configurationsForEnvCreation[this.environment]['partnerPayload']['shash'] = salt;
    //         this.configurationsForEnvCreation[this.environment]['partnerPayload']['account_password'] = this.encrypt(salt, iv, this.passphrase, this.password, this.keySize, this.iterationCount);
    //         this.configurationsForEnvCreation[this.environment]['partnerPayload']['accounts'][0]['account_password'] = this.encrypt(salt, iv, this.passphrase, this.password, this.keySize, this.iterationCount);
    //       } else {
    //         this.configurationsForEnvCreation[this.environment]['partnerPayload']['account_password'] = '';
    //         this.configurationsForEnvCreation[this.environment]['partnerPayload']['accounts'][0]['account_password'] = '';
    //       }
    //     }
    //   }
    //   for (const service of this.configurationsForEnvCreation[this.environment].settingsPayload.environments[0].services) {
    //     if (service.type === 'databases') {
    //       if (this.databasesPayload.length > 0) {
    //         this.databasesPayload[0]['connection_provider'] = 'external';
    //         this.databasesPayload[0]['is_default'] = true;
    //         if (this.databasesPayload[0]['database_type'] === 'mongodb' || this.databasesPayload[0]['database_type'] === 'dynamodb') {
    //           this.databasesPayload[0]['is_nosql'] = true;
    //           service.configurations[0]['is_nosql'] = true;
    //         } else {
    //           this.databasesPayload[0]['is_nosql'] = false;
    //           service.configurations[0]['is_nosql'] = false;
    //         }
    //         // this.configurationsForEnvCreation[this.environment]['partnerPayload']['databases'] = this.databasesPayload;
    //         // this.configurationsForEnvCreation[this.environment]['partnerPayload']['defaultDatabaseType'] = this.databasesPayload[0]['database_type'];
    //
    //         if (this.configurationsForEnvCreation[this.environment]['partnerPayload'].hasOwnProperty('databases')) {
    //           delete this.configurationsForEnvCreation[this.environment]['partnerPayload']['databases'];
    //         }
    //         if (this.configurationsForEnvCreation[this.environment]['partnerPayload'].hasOwnProperty('defaultDatabaseType')) {
    //           delete this.configurationsForEnvCreation[this.environment]['partnerPayload']['defaultDatabaseType'];
    //         }
    //
    //         const dbAttributes = JSON.parse(JSON.stringify(this.databasesPayload[0]['database_attributes']));
    //         const attributes = Object.keys(dbAttributes);
    //         const result = {};
    //         if (attributes && attributes.length > 0) {
    //           for (let i = 0; i < attributes.length; i++) {
    //             await this.platform.encryptAttribute(salt, iv, this.passphrase, dbAttributes[attributes[i]], this.keySize, this.iterationCount).then(response => {
    //               result[attributes[i]] = response;
    //             });
    //           }
    //         }
    //         service.configurations[0]['shash'] = salt;
    //         service.configurations[0]['ralam'] = iv;
    //         // service.configurations[0]['database_type'] = this.item['databases'][0]['database_type'];
    //         service.configurations[0]['database_type'] = this.databasesPayload[0]['database_type'];
    //         // service.configurations[0]['database_name'] = this.item['databases'][0]['database_name'];
    //         service.configurations[0]['database_name'] = 'default';
    //         // service.configurations[0]['database_attributes'] = this.item['databases'][0]['database_attributes'];
    //         service.configurations[0]['database_attributes'] = result;
    //         service.configurations[0]['region'] = '';
    //         service.configurations[0]['connection_provider'] = 'external';
    //         service.configurations[0]['audit_logs'][0] = {
    //           action: 'CREATE',
    //           by: localStorage.getItem('signInEmail'),
    //           at: Date.now()
    //         };
    //         this.configurationsForEnvCreation[this.environment]['selectedAPIGateway'] = this.selectedAPIGateway;
    //         this.createEnvironment.emit(this.configurationsForEnvCreation);
    //       } else {
    //         // const dbPayload = [{
    //         //   database_type: this.databaseSelected,
    //         //   database_name: 'default',
    //         //   database_attributes: {
    //         //     dbName: dbName
    //         //   },
    //         //   region: '',
    //         //   connection_provider: 'apiplatform',
    //         //   is_default: true
    //         // }];
    //         // this.configurationsForEnvCreation[this.environment]['partnerPayload']['databases'] = dbPayload;
    //
    //
    //         // this.configurationsForEnvCreation[this.environment]['partnerPayload']['databases'] = [];
    //         // this.configurationsForEnvCreation[this.environment]['partnerPayload']['defaultDatabaseType'] = this.databaseSelected;
    //
    //         if (this.configurationsForEnvCreation[this.environment]['partnerPayload'].hasOwnProperty('databases')) {
    //           delete this.configurationsForEnvCreation[this.environment]['partnerPayload']['databases'];
    //         }
    //         if (this.configurationsForEnvCreation[this.environment]['partnerPayload'].hasOwnProperty('defaultDatabaseType')) {
    //           delete this.configurationsForEnvCreation[this.environment]['partnerPayload']['defaultDatabaseType'];
    //         }
    //
    //         this.createDatabaseAndCreateEnvironment(salt, iv);
    //
    //         // service.configurations[0]['database_type'] = this.item['databases'][0]['database_type'];
    //         // service.configurations[0]['database_name'] = this.item['databases'][0]['database_name'];
    //         // service.configurations[0]['database_attributes'] = {
    //         //   dbName: dbName
    //         // };
    //         // service.configurations[0]['region'] = '';
    //         // service.configurations[0]['connection_provider'] = 'apiplatform';
    //         // service.configurations[0]['audit_logs'][0] = {
    //         //   action: 'CREATE',
    //         //   by: localStorage.getItem('signInEmail'),
    //         //   at: Date.now()
    //         // };
    //       }
    //     }
    //   }
    // } else {
    //   alert('Passwords do not match');
    // }
  }

  editDialog() {
    const dialogRef = this.dialog.open(EditDatabaseDuringSignUpComponent, {
      disableClose: true,
      width: '50%',
      data: this.databasesPayload
    });

    dialogRef.afterClosed().subscribe(result => {
      this.databasesPayload[0] = result;
      this.showDefaultView = false;
    });
  }

  createDatabaseAndCreateEnvironment(salt, iv) {
    let dbName = '';
    if (this.environment === 'prod') {
      dbName = this.partnerShortCode;
    } else {
      dbName = this.environment + this.partnerShortCode;
    }
    this.platform.createDatabaseInApiplatform('admin-' + this.partnerShortCode, {databaseType: this.databaseSelected, databaseName: dbName}).then(async response => {
      const dbPayload = [{
        database_type: this.databaseSelected,
        database_name: 'default',
        database_attributes: {
          dbName: dbName
        },
        region: '',
        connection_provider: 'apiplatform',
        is_default: true
      }];
      if (this.databaseSelected === 'mongodb' || this.databaseSelected === 'dynamodb') {
        dbPayload[0]['is_nosql'] = true;
      } else {
        dbPayload[0]['is_nosql'] = false;
      }
      // this.configurationsForEnvCreation[this.environment]['partnerPayload']['databases'] = dbPayload;

      if (this.configurationsForEnvCreation[this.environment]['partnerPayload'].hasOwnProperty('databases')) {
        delete this.configurationsForEnvCreation[this.environment]['partnerPayload']['databases'];
      }
      if (this.configurationsForEnvCreation[this.environment]['partnerPayload'].hasOwnProperty('defaultDatabaseType')) {
        delete this.configurationsForEnvCreation[this.environment]['partnerPayload']['defaultDatabaseType'];
      }

      for (const service of this.configurationsForEnvCreation[this.environment].settingsPayload.environments[0].services) {
        if (service.type === 'databases') {

          const dbAttributes = JSON.parse(JSON.stringify(dbPayload[0]['database_attributes']));
          const attributes = Object.keys(dbAttributes);
          const result = {};
          if (attributes && attributes.length > 0) {
            for (let i = 0; i < attributes.length; i++) {
              await this.platform.encryptAttribute(salt, iv, this.passphrase, dbAttributes[attributes[i]], this.keySize, this.iterationCount).then(response1 => {
                result[attributes[i]] = response1;
              });
            }
          }

          service.configurations[0]['shash'] = salt;
          service.configurations[0]['ralam'] = iv;
          // service.configurations[0]['database_type'] = this.item['databases'][0]['database_type'];
          service.configurations[0]['database_type'] = this.databaseSelected;
          // service.configurations[0]['database_name'] = this.item['databases'][0]['database_name'];
          service.configurations[0]['database_name'] = 'default';
          service.configurations[0]['database_attributes'] = result;
          service.configurations[0]['region'] = '';
          service.configurations[0]['connection_provider'] = 'apiplatform';
          service.configurations[0]['audit_logs'][0] = {
            action: 'CREATE',
            by: localStorage.getItem('signInEmail'),
            at: Date.now()
          };
          if (this.databaseSelected === 'mongodb' || this.databaseSelected === 'dynamodb') {
            service.configurations[0]['is_nosql'] = true;
          } else {
            service.configurations[0]['is_nosql'] = false;
          }
        }
      }
      this.configurationsForEnvCreation[this.environment]['selectedAPIGateway'] = this.selectedAPIGateway;
      this.createEnvironment.emit(this.configurationsForEnvCreation);
    }, error => {
      for (const service of this.configurationsForEnvCreation[this.environment].settingsPayload.environments[0].services) {
        if (service.type === 'databases') {
          service.configurations = [];
        }
      }
      // this.configurationsForEnvCreation[this.environment]['partnerPayload']['databases'] = [];
      // this.configurationsForEnvCreation[this.environment]['selectedAPIGateway'] = this.selectedAPIGateway;
      if (this.configurationsForEnvCreation[this.environment]['partnerPayload'].hasOwnProperty('databases')) {
        delete this.configurationsForEnvCreation[this.environment]['partnerPayload']['databases'];
      }
      if (this.configurationsForEnvCreation[this.environment]['partnerPayload'].hasOwnProperty('defaultDatabaseType')) {
        delete this.configurationsForEnvCreation[this.environment]['partnerPayload']['defaultDatabaseType'];
      }
      this.createEnvironment.emit(this.configurationsForEnvCreation);
    });
  }

}
